import {User}									from '../user/interface';
import {ApiContractNotValalaState}				from './interface';

import * as API									from '../../ressources/API';


export default {
	getContractsNotValalaApi: async (user: User) => {
		const response = await API.getContractsNotValala(user);
		if (!response || !response.status)
			return [];
		return response.data;
	},
	postContractsNotValalaApi: async (data: ApiContractNotValalaState) => {
		const response = await API.postContractNotValala(data.data, data.user);
		if (!response || !response.status)
			return response;
		return response.data;
	},
	putContractsNotValalaApi: async (data: ApiContractNotValalaState) => {
		if (!data.idContract)
			return null;

		const response = await API.putContractNotValala(data.idContract, data.data, data.user);
		if (!response || !response.status)
			return null;
		return response.data;
	}
};
